import { useState } from "react";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Info } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { dashboardLabels } from "@/i18n";
import { cn } from "@/lib/utils";
import { nativeNestedSheetDialogProps } from "@/lib/native/nativeNestedSheetProps";

export const ModalInfoVehicleTest = () => {
  const { language } = useLanguage();
  const [open, setOpen] = useState(false);
  const nestedSheetProps = nativeNestedSheetDialogProps(open);
  const qg = dashboardLabels(language).quickGuide ?? {};
  const title = qg.vehicleTestTitle ?? "Vad är Fordonstest?";
  const aria = qg.vehicleTestAria ?? "Vad är Fordonstest?";

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button
          type="button"
          className="flex items-center gap-1 px-2 py-1 rounded-lg border-2 border-primary/30 bg-primary/10 hover:bg-accent/50 text-blue-400 text-xs font-semibold focus:outline-none"
          aria-label={aria}
        >
          {title} <Info className="w-4 h-4" />
        </button>
      </DialogTrigger>
      <DialogContent
        {...nestedSheetProps}
        className={cn(nestedSheetProps.className, "max-w-lg max-h-[90vh] overflow-y-auto")}
      >
        <div className="text-sm space-y-4">
          <h3 className="font-semibold text-lg text-blue-500">{title}</h3>
          <p>{qg.vehicleTestIntro}</p>
          <p>{qg.vehicleTestSections}</p>
          <ul className="list-disc list-inside space-y-2 ml-2">
            <li>{qg.vehicleTestSpeed}</li>
            <li>{qg.vehicleTestVibrations}</li>
            <li>{qg.vehicleTestLeaks}</li>
            <li>{qg.vehicleTestNoises}</li>
            <li>{qg.vehicleTestGearbox}</li>
            <li>{qg.vehicleTestCrash}</li>
            <li>{qg.vehicleTestAc}</li>
            <li>{qg.vehicleTestDashboard}</li>
            <li>{qg.vehicleTestWindshield}</li>
            <li>{qg.vehicleTestBrakes}</li>
            <li>{qg.vehicleTestTires}</li>
          </ul>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-lg space-y-2">
            <p className="text-blue-700 dark:text-blue-300">
              👍 {qg.vehicleTestCta}
            </p>
            <p className="text-blue-700 dark:text-blue-300">
              👍 {qg.vehicleTestTip}
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
